import React, {useState} from 'react';
import {useDialog, useTranslate} from '../../../hooks';
import {PaymentFreeMonthDialogUpdate} from './PaymentFreeMonthDialogUpdate';
import {PaymentFreeMonthDialogSuccess} from './PaymentFreeMonthDialogSuccess';
import {BaseDialog, KeyRouter} from '@resurs-internal/mui';

export type PaymentFreeMonthDialogRoutes = 'update' | 'success' | 'close';
export const PaymentFreeMonthDialog: React.FC = () => {
  const translate = useTranslate();
  const {open, onClose} = useDialog('payment-free-month');
  const [routeKey, setRouteKey] = useState('update');
  const navigate = (key: PaymentFreeMonthDialogRoutes) => {
    if (key === 'close') return onClose();
    setRouteKey(key);
  };
  return (
    <BaseDialog
      header={translate('payment-free-month.dialog.title')}
      open={open}
      onClose={onClose}>
      <KeyRouter
        current={routeKey}
        routes={{
          update: <PaymentFreeMonthDialogUpdate navigate={navigate} />,
          success: <PaymentFreeMonthDialogSuccess navigate={navigate} />,
        }}
      />
    </BaseDialog>
  );
};
